export interface EmployeesRouter {
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployeesRouter = Symbol('EmployeesRouter');
